import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import { GeneralAlert } from '../../components/Alert/Alert';
import { sweetAlert } from "../../components/Alert/sweetAlert";
import { SweetConfirmationAlert } from '../../components/Alert/sweetAlert';
import { ResidentSelect, renderTextFieldWithChips, renderTextField } from '../../utils/engageComponents'
import DeviceFiltersDrawer from "./DeviceFiltersDrawer";
import { Tab, Tabs } from '@material-ui/core';


import {
    GetDevicesSorted,
    AddDevice,
    GetDevice,
    UpdDevice,
    AddMessage,
    UnregisterResidents,
    GetDevicesLocations,
    GetDevicesResidents,
    GetDevicesSerials,
    UnregisterResidentsFilter,
    AddMessageFilter
} from '../../actions/deviceActions';
import { GetIcons } from '../../actions/categoryActions'
import { getResidentsByCommunity } from '../../actions/residentActions';
import { ExportDevices } from "../../actions/deviceActions";

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

import { currentScrollingPage, itemPerPage } from "../../constants/index";

import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IconButton from '@material-ui/core/IconButton';
import { Button, Switch } from "@material-ui/core";

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import SwipeableViews from 'react-swipeable-views';
import { ChevronList } from '../../utils/engageComponents';
import { IconsModal } from '../scheduler/IconsModal';

import Alert from 'react-s-alert';

//FontAwesome

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClipboardList,
    faGlobe,
    faSort,
    faSortAlphaDown,
    faSortAlphaUpAlt,
    faSortNumericDown,
    faSortNumericUpAlt,
} from "@fortawesome/free-solid-svg-icons";


//Icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//3 party Libs
import moment from 'moment';
import { ADD_DEVICE_SUCCESS, UPDATE_DEVICE_SUCCESS } from "../../constants/devicesConstants";

const validate = (values) => {
    const errors = {};

    return errors;
};


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class AddEditDeviceV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            tableData: [],
            currentPage: currentScrollingPage,
            itemPerPage: itemPerPage,
            action: props.data && props.data._id ? 'edit' : 'new',
            _id: props.data._id,
            registrationCode: undefined,
            errorGenericText: 'Required Field',
            selectAllButton: false,
            selectedDevices: [],
            communityData: props.data,
            //Modal
            activeStep: 0,
            openModal: false,
            residentSelected: undefined,
            onErrorModalRegistrationCode: true,
            onErrorModalRegisteredResident: true,
            //UpdDevices
            residentDetailSelected: undefined,
            isUpdDevice: false,
            deviceSelected: undefined,
            chipsArray: (props.data && props.data.tags) ? props.data.tags : [],
            textFieldActualText: '',
            //MessageModal
            openMessageModal: false,
            notificationMessage: true,
            fullscreenMessage: false,
            hourSelected: undefined,
            minuteSelected: undefined,
            dayTime: undefined,
            scheduleDay: undefined,
            fixedOptionSelected: undefined,
            onErrorModalTitle: true,
            onErrorModalMessage: true,
            messageModalSeconds: 30,
            messageModalHours: 2,
            fullNotificationIconSelected: undefined,
            fullNotificationIconUrl: undefined,
            openIconsModal: false,
            openIconsCombo: false,

            //RebootModal
            openRebootModal: false,
            rebootMessage: false,

            disabledBackIcon: true,
            disabledFowardIcon: false,
            stepCounter: 0,


            //Device filters
            openFilters: false,
            AnchorElId: undefined,
            filterObj: undefined,
            devices: this.props.tableData ? this.props.tableData : [],
            openTranslations: false,
            translationTab: 0,
            titleEs: '',
            titleFr: '',
            messageEs: '',
            messageFr: '',

            //Sorting
            sortColumn: 'lowerName',
            sortDesc: true
        };

        this.observer = React.createRef();
        this.lastDeviceRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }), async () => {
                        const resp = await this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);

                        if (this.state.selectAllButton && resp)
                            this.SelectAllDevicesActive(resp);

                    });



                }
            });
            if (node) this.observer.current.observe(node)

        }

    }

    interval = undefined;
    //This method will run once the componnet is deploy to the browser
    componentDidMount() {
        document.title = 'Community - Devices'

        this.props.GetIcons();
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
        this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);

        this.props.getResidentsByCommunity(this.props.data._id);

        this.props.GetDevicesLocations(communityId);
        this.props.GetDevicesSerials(communityId);
        this.props.GetDevicesResidents(communityId);

        //Interval for geting all devices 
        const umbralinMiliseconds = ((this.props && this.props.umbralInMinutes) ? this.props.umbralInMinutes : 5) * 60 * 1000;
        const miliseconds = umbralinMiliseconds - 1000;

        this.interval = setInterval(() => {
            this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);

        }, miliseconds);


        this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);

        setTimeout(() => {
            let newDeviceSelected = undefined;
            if (this.state.deviceSelected && this.props.tableData) {
                newDeviceSelected = this.state.deviceSelected;
                const lastConnDeviceSelected = this.props.tableData.find((item) => item._id === this.state.deviceSelected._id);
                newDeviceSelected.lastConnectionDate = (lastConnDeviceSelected && lastConnDeviceSelected.lastConnectionDate) ? lastConnDeviceSelected.lastConnectionDate : undefined;
            }


            this.setState({
                selectedDevices: [],
                deviceSelected: newDeviceSelected,
            })
        }, 500);

    };

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }

    };

    objStyles = {
        titleEngage: {
            color: '#686868',
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'left',
            marginBottom: '5px'
        }
    }
    //This methos is responsable to handle the click in cancel button
    //it does set state prop OPEN to false so in a rerender this component will not be render (it render the list of issues)
    //set the prop itemsByissue to []
    handleCancel = () => {
        if (this.state.open) {
            this.setState({ open: false, selectAllButton: false, selectedDevices: [] });
            this.props.closeDialog();
            this.props.isSelectedDevices([])
        }
    };


    //#region Device Update
    StyleDeviceForm = {
        GridForm: {
            height: '400px',
            justify: 'center',
            padding: '20px'
        },
        GridContent: {
            backgroundColor: '#1f1f1f',
            marging: '10px',
            padding: '25px',
            borderRadius: '4px'
        }
    }

    inputHidden = {
        display: 'none'
        // displayComponent: 'none'
    }

    onSubmitHandler = (formData) => {
        this.props.UpdDevice(this.state.deviceSelected._id, formData, localStorage.getItem('communityId'))
    }
    //#endregion


    //#region  PAGINATION
    handlePageChange = (number) => {

        if (number && typeof (number) == 'number' && number > 0) {
            this.setState({
                currentPage: Number(number)
            });
        }

    };

    //#endregion


    //#region methods

    CheckForValidCaracters = (input) => {
        let pattern = '[0-9]';

        if (input.length > 6) {
            return input.substring(0, input.length - 1);
        }

        if (input.length !== 6) {
            this.setState({ onErrorModalRegistrationCode: true });
        } else {
            this.setState({ onErrorModalRegistrationCode: false });
        }

        if (input.length > 0) {
            var regex = new RegExp(pattern);
            if (regex.test(input)) {
                return input;
            } else {
                return input.substring(0, input.length - 1);
            }
        } else {
            return input;
        }

    };

    isOnError = (field) => {

        switch (field.toLocaleLowerCase()) {
            case 'registrationcode':
                this.setState({ onErrorModalRegistrationCode: (this.state.registrationCode === '' || this.state.registrationCode === undefined) });
                break;
            default: break;

        }
    };


    //#region Modal
    Modal = {
        paperModal: {
            backgroundColor: '#1f1f1f',
            padding: '6px',
            width: '35%',
            height: '50%',
            position: 'absolute',
            top: '20%',
            left: '35%'
        },
        stepperModal: {
            height: '10%',
        },
        contentModal: {
            height: '60%',
            padding: '20px'
        },
        buttonsModal: {
            height: '40%',
            justify: 'center',
            marginTop: '20px',
        },
        hiddenButton: {
            display: 'none'
        },
        visibleButton: {
            marginTop: '10px',
            marginLeft: '10px',
            width: '156px'
        },
        visibleDisabledButton: {
            marginTop: '10px',
            marginLeft: '10px',
            backgroundColor: '#ffffff',
            color: '#bdbdbd',
            width: '7rem'
        }
    }

    cleanModal = () => {
        this.setState({
            openModal: false,
            activeStep: 0,
            residentSelected: undefined,
            registrationCode: undefined,
            onErrorModalRegisteredResident: true,
            onErrorModalRegistrationCode: true,
            selectAllButton: false,

            //MessageModal
            openMessageModal: false,
            notificationMessage: true,
            fullscreenMessage: false,
            messageModalTitle: undefined,
            messageModalMessage: undefined,
            scheduleDay: undefined,
            hourSelected: undefined,
            minuteSelected: undefined,
            dayTime: undefined,
            disabledMessageBackIcon: true,
            disabledMessageFowardIcon: false,
            messageStepCounter: 0,
            fixedOptionSelected: undefined,
            messageModalSeconds: 30,
            messageModalHours: 2,
            fullNotificationIconSelected: undefined,
            fullNotificationIconUrl: undefined,
            openIconsModal: false,
            openIconsCombo: false,

            //RebootModal
            openRebootModal: false,
            rebootMessage: false,


            disabledBackIcon: true,
            disabledFowardIcon: false,
            stepCounter: 0,

            openTranslations: false,
            translationTab: 0,
            titleEs: '',
            titleFr: '',
            messageEs: '',
            messageFr: ''

        });
    }

    notificationClick = () => {
        const notification = this.state.notificationMessage;

        this.setState({
            notificationMessage: !notification,
            fullscreenMessage: false
        });
    }

    fullClick = () => {
        const full = this.state.fullscreenMessage;

        this.setState({
            notificationMessage: false,
            fullscreenMessage: !full
        });
    }

    handleAddDevice = () => {
        if (!(this.state.onErrorModalRegistrationCode || this.state.onErrorModalRegisteredResident)) {
            this.createNewDevice();
            setTimeout(() => {
                this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
            }, 150);
            this.cleanModal();
        }
    };

    createNewDevice = () => {

        const newDevice = {}
        newDevice.communityId = localStorage.getItem('communityId');
        newDevice.registrationcode = this.state.registrationCode;
        newDevice.residentId = this.state.residentSelected._id;
        newDevice.residentName = this.state.residentSelected.firstName + ' ' + this.state.residentSelected.lastName;
        newDevice.residentLocation = this.state.residentSelected.zoneName;
        newDevice.residentPictureUrl = this.state.residentSelected.pictureUrl;
        newDevice.language = 'en';

        //Map the selected language to send the correct languagecode
        switch (this.state.residentSelected.preferedLanguage) {
            case 'Spanish':
                newDevice.language = 'es'
                break;
            case 'French':
                newDevice.language = 'fr'
                break;
            case 'English':
                newDevice.language = 'en'
                break;
            default:
                newDevice.language = 'en'
                break;
        }

        this.props.AddDevice(newDevice);

        //this.cleanModal();
    };


    //#endregion

    async handleEdit(e, item) {

        const deviceSelected = await this.props.GetDevice(item._id, localStorage.getItem('communityId'))

        this.props.isUpdateDevice(true, deviceSelected);
        this.props.isSelectedDevices([item]);
        if (deviceSelected) {
            this.setState({
                isUpdDevice: true,
                selectedDevices: [item],
                selectAllButton: false,
                deviceSelected: deviceSelected,
                chipsArray: deviceSelected.tags,
                residentDetailSelected: this.props.residentData.find(res => res._id === deviceSelected.residentId)
            });
        }
    };

    //Chips
    handlerOnChipDelete = (chipText) => {
        let newChipArray = this.state.chipsArray;
        const index = newChipArray.indexOf(chipText);

        if (index !== -1) {
            newChipArray.splice(index, 1);
            this.setState({ chipsArray: newChipArray })
        }

    };
    handleOnchangeTextField = (newText) => {
        this.setState({ textFieldActualText: newText });
    };
    handleOnClickAddButton = () => {
        const textNewChip = this.state.textFieldActualText;
        const index = this.state.chipsArray.indexOf(textNewChip);
        let chips = this.state.chipsArray;

        if (chips.length < 10) {
            if (textNewChip.length <= 25) {
                if (index === -1 && textNewChip.length > 0) {
                    chips.push(textNewChip)
                    this.setState({ chipsArray: chips })
                }
            } else {
                const message = 'The identifier should contain less than 25 characters';
                GeneralAlert('error', message);
            }
        } else {
            const message = 'Can´t add more than 10 identifiers per device';
            GeneralAlert('error', message);
        }
        this.props.dispatch(change('DeviceForm', 'DeviceTags', ''));
    };

    handleCancelUpdateDevice = () => {
        this.setState({ isUpdDevice: false, deviceSelected: undefined, selectedDevices: [], selectAllButton: false });
        this.props.isSelectedDevices([]);
        this.props.isUpdateDevice();
    }

    handleExport = () => {
        this.props.ExportDevices(localStorage.getItem('communityId'), this.state.communityData.communityName);
    }

    handleUnregister = async () => {
        const title = 'Are you sure you want to unregister the resident(s)?';
        const { isConfirmed } = await SweetConfirmationAlert(title, 'alert_unregisterResident');

        if (isConfirmed) {

            const newMessage = {}
            newMessage.notificationType = "Full"
            newMessage.notificationType = "Unregistration"
            newMessage.messageType = "Normal"

            newMessage.topics = [];

            this.state.selectedDevices.forEach(selected => {
                newMessage.topics.push(`${selected.residentId}/${selected._id}`);
            });

            let messageDate = moment(new Date());

            newMessage.messageDate = messageDate

            if (this.state.selectAllButton)
                this.props.UnregisterResidentsFilter(localStorage.getItem('communityId'), this.state.filterObj, newMessage, this.state.sortColumn, this.state.sortDesc);
            else
                this.props.UnregisterResidents(this.state.selectedDevices, localStorage.getItem('communityId'), newMessage);

            setTimeout(() => {
                const communityId = localStorage.getItem('communityId');
                if (communityId) {
                    this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
                }
            }, 150);

            this.setState({ isUpdDevice: false, deviceSelected: undefined, selectedDevices: [], selectAllButton: false });
            this.handleCancelUpdateDevice();

            Alert.closeAll();
        }
    }

    handleUpdateDevice = () => {
        this.props.UpdDevice(this.state.deviceSelected._id, this.state.deviceSelected, localStorage.getItem('communityId'))
        setTimeout(() => {
            this.props.GetDevicesSorted(localStorage.getItem('communityId'), 0, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
        }, 150);
        this.setState({ isUpdDevice: false, deviceSelected: undefined, selectedDevices: [], currentPage: 0 })
        this.props.isUpdateDevice();
    }


    //#region  Inner Components -Get status icons
    GetStatusIcons = ({ active = false, lastConnectionDate = undefined }) => {

        const now = new Date();
        const lastConn = lastConnectionDate ? new Date(lastConnectionDate) : undefined;

        const umbralInMinutes = this.props.umbralInMinutes ? this.props.umbralInMinutes : 5;
        let lastConnectionWithinUmbral = false;

        if (!lastConn || isNaN(lastConn.getTime())) {
            lastConnectionWithinUmbral = false;
        } else {
            lastConnectionWithinUmbral = (umbralInMinutes * 60 * 1000) > (now.getTime() - lastConn.getTime());
        }




        return (
            <Grid item container justify='center' alignContent='center'>
                <Grid item style={{ margin: '0 5px', marginRight: '35px' }}>
                    <FontAwesomeIcon
                        className="icon-menu-size"
                        icon={faClipboardList}
                        style={{ color: active ? '#5BDB86' : '#959494' }}
                    />
                </Grid>
                <Grid item style={{ margin: '0 5px' }}>
                    <FontAwesomeIcon
                        className="icon-menu-size"
                        icon={faGlobe}
                        style={{ color: lastConnectionWithinUmbral ? '#5BDB86' : '#959494' }}
                    />
                </Grid>
            </Grid>
        );
    }
    //#endregion

    //#region deviceCheckBox

    ToogleCheckBoxHandler = (device) => {

        if (this.state.selectedDevices) {
            const arrayDeviceSelected = this.state.selectedDevices;

            const item = arrayDeviceSelected.find(item => item._id === device._id);

            if (!item) {
                arrayDeviceSelected.push(device);

                if (arrayDeviceSelected.length === this.props.tableData.length)
                    this.setState({ selectAllButton: true });
            }
            else {
                const indexToDelete = arrayDeviceSelected.map(item => item._id).indexOf(device._id);
                arrayDeviceSelected.splice(indexToDelete, 1);
                this.setState({ selectAllButton: false });
            }
            this.setState({ selectedDevices: arrayDeviceSelected });

            this.props.isSelectedDevices(arrayDeviceSelected);
        }
    };

    SelectAllDevicesActive = (newData = []) => {
        let arrayDeviceSelected = this.state.selectedDevices ? this.state.selectedDevices : [];
        if (newData) {
            newData.forEach(item => {
                const indexOfItemAllReadySelected = (this.state.selectedDevices) ? this.state.selectedDevices.map(item => item._id).indexOf(item._id) : -1;

                if (indexOfItemAllReadySelected === -1) {

                    arrayDeviceSelected.push(item);
                }
            }
            );

            this.setState({ selectedDevices: arrayDeviceSelected })
        }
    }

    SelectAllDevicesHandler = () => {
        const selectAllButton = !this.state.selectAllButton;
        let arrayDeviceSelected = this.state.selectedDevices ? this.state.selectedDevices : [];

        if (selectAllButton === true) {
            if (this.props.tableData) {
                this.props.tableData.forEach(item => {
                    const indexOfItemAllReadySelected = (this.state.selectedDevices) ? this.state.selectedDevices.map(item => item._id).indexOf(item._id) : -1;

                    if (indexOfItemAllReadySelected === -1) {

                        arrayDeviceSelected.push(item);
                    }
                }
                );
            }
        }
        else {
            if (this.props.tableData) {
                this.props.tableData.forEach(item => {

                    if (this.state.selectedDevices) {
                        const indexToDelete = this.state.selectedDevices.map(item => item._id).indexOf(item._id);

                        if (indexToDelete !== -1) {

                            arrayDeviceSelected.splice(indexToDelete, 1);
                        }
                    }
                });
            }
        }
        this.setState({ selectedDevices: arrayDeviceSelected, selectAllButton: selectAllButton });

        this.props.isSelectedDevices(arrayDeviceSelected);
    };
    onChangeHandler = (e, placeholder) => {

        let timeValue = e.target.value.slice(-2)

        if (placeholder === 'hr') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 12)) {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = 0;

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            } else {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = Number(e.target.value);

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'min') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 59)) {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = 0;

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            } else {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = Number(e.target.value.slice(-2));

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'AM') {
            if (!(e.target.value === 'AM' || e.target.value === 'PM')) {
                this.setState({ dayTime: { text: 'AM' }, fixedOptionSelected: undefined });
            }
        }

    }

    onArrowClick = (order, placeHolder) => {

        if (placeHolder === 'hr') {
            let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
            let hour = hourObject.number ? hourObject.number : 0;

            if (order === 'Up') {

                if ((hour + 1) < 13) {
                    hour = hour + 1;
                }
            }
            else {
                if ((hour - 1) > 0) {
                    hour = hour - 1;
                }
            }

            hourObject.number = hour;
            hourObject.text = ('0' + hour).slice(-2);

            this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
        }

        if (placeHolder === 'min') {
            let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
            let minute = minuteObject.number ? minuteObject.number : 0;
            if (order === 'Up') {

                if ((minute + 1) < 60) {
                    minute = minute + 1;
                }
            }
            else {
                if ((minute - 1) > -1) {
                    minute = minute - 1;
                }
            }

            minuteObject.number = minute;
            minuteObject.text = ('0' + minute).slice(-2)

            this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
        }

        if (placeHolder === 'AM') {
            let dayTime = 'AM';
            if (this.state.dayTime === undefined || this.state.dayTime.text === 'PM') {
                dayTime = 'AM';
            }
            else {
                dayTime = 'PM';
            }

            this.setState({ dayTime: { text: dayTime }, fixedOptionSelected: undefined });
        }
    }


    SelectOptionForMessage = (scheduleDate, option) => {

        let hour = scheduleDate.hour() > 12 ? scheduleDate.hour() - 12 : scheduleDate.hour();
        let minute = scheduleDate.minutes();
        let dayTime = scheduleDate.hour() > 11 ? 'PM' : 'AM';
        let daySelected = scheduleDate.clone().startOf('day');

        if (this.state.fixedOptionSelected && this.state.fixedOptionSelected === option) {
            option = undefined;
            hour = undefined;
            minute = undefined;
            dayTime = undefined;
            daySelected = undefined;
        };

        let hourObject = {
            number: undefined,
            text: '',
        }

        let minuteObject = {
            number: undefined,
            text: '',
        }

        const datTimeObject = {
            text: dayTime,
        }


        if (hour === undefined) {
            hourObject = {
                number: undefined,
                text: '',
            }
        } else {

            hourObject = {
                number: hour,
                text: ('0' + hour).slice(-2),
            }
        }

        if (minute === undefined) {
            minuteObject = {
                number: undefined,
                text: '',
            }
        } else {

            minuteObject = {
                number: minute,
                text: ('0' + minute).slice(-2),
            }
        }


        this.setState({
            fixedOptionSelected: option,
            hourSelected: hourObject,
            minuteSelected: minuteObject,
            dayTime: datTimeObject,
            scheduleDay: daySelected,
        });

    }

    handleDayClick = (day, today) => {

        if (day >= today) { this.setState({ scheduleDay: day }) }

        if (this.state.fixedOptionSelected !== undefined) {

            setTimeout(() => {

                const daySelected = moment(this.state.scheduleDay).format('DDDD');
                const todayD = moment(today).format('DDDD');
                const Tomorrow = moment(today).add(1, 'day').format('DDDD');

                if ((this.state.fixedOptionSelected === 1 || this.state.fixedOptionSelected === 2) && daySelected !== todayD) {

                    this.setState({ fixedOptionSelected: undefined });

                }
                else if (this.state.fixedOptionSelected === 3 && daySelected !== Tomorrow) {

                    this.setState({ fixedOptionSelected: undefined });

                }
            }, 300);
        }
    }

    handleOnchangeTitleField = (value) => {

        let validValue = value;

        if (value.length > 25) {
            validValue = value.substring(0, value.length - (value.length - 25));
            this.setState(
                {
                    onErrorModalTitle: true,
                    messageModalTitle: validValue,
                    errorMaxCharactersTitle: 'The title can only contain up to 25 characters'
                }
            );

        } else {
            this.setState(
                {
                    onErrorModalTitle: value.length > 0 ? false : true,
                    messageModalTitle: validValue,
                    errorMaxCharactersTitle: undefined
                }
            );
        }

    }

    handleOnchangeMessageField = (value) => {
        let validValue = value;

        if (this.state.fullscreenMessage && value.length > 220) {

            validValue = value.substring(0, value.length - (value.length - 220));

            this.setState(
                {
                    onErrorModalMessage: true,
                    messageModalMessage: validValue,
                    errorMaxCharactersBody: 'The body of the message can only contain up to 220 characters'

                }
            );
        } else if (!this.state.fullscreenMessage && value.length > 40) {
            validValue = value.substring(0, value.length - (value.length - 40));

            this.setState(
                {
                    onErrorModalMessage: true,
                    messageModalMessage: validValue,
                    errorMaxCharactersBody: 'The message can only contain up to 40 characters'

                }
            );
        }
        else {
            this.setState(
                {
                    onErrorModalMessage: value.length > 0 ? false : true,
                    messageModalMessage: validValue,
                    errorMaxCharactersBody: undefined
                }
            );
        }

    }

    handleOnchangeMessageTime = (value) => {
        if (this.state.fullscreenMessage)
            this.setState(
                {
                    messageModalHours: value
                }
            );
        else
            this.setState(
                {
                    messageModalSeconds: value
                }
            );
    }


    handleAddMessage = () => {
        if (this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.hourSelected === undefined || this.state.minuteSelected === undefined)
            return;


        if (!(this.state.onErrorModalMessage)) {
            this.createMessage();

            const updState = {
                fullNotificationIconSelected: undefined,
                fullNotificationIconUrl: undefined
            }

            //If we are on the list of devices, clear the devices selected, if we are on the details don't
            if (!this.state.isUpdDevice) {
                updState.selectedDevices = [];
                this.props.isSelectedDevices([]);
            }

            this.setState(updState);
        }
    };

    handleAddReboot = () => {

        if (this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.minuteSelected === undefined || this.state.hourSelected === undefined)
            return

        this.createMessage();

        this.setState({ selectedDevices: [] });
        this.props.isSelectedDevices([]);
    };

    AddStep = (step) => {

        let newValue = this.state.stepCounter + step;
        this.setState({ stepCounter: newValue });

        if (newValue === 1)
            this.setState({ disabledBackIcon: false, disabledFowardIcon: true });
        else
            this.setState({ disabledBackIcon: true, disabledFowardIcon: false });
    }

    async createMessage() {

        const newMessage = {}
        newMessage.notificationType = this.state.notificationMessage ? "Notification" : "Full"
        newMessage.notificationType = this.state.rebootMessage ? "Reboot" : newMessage.notificationType
        newMessage.messageType = this.state.fixedOptionSelected === 1 ? "Normal" : "Reminder"
        newMessage.title = this.state.messageModalTitle;
        newMessage.message = this.state.messageModalMessage;
        newMessage.topics = [];
        newMessage.fullNotificationIconUrl = this.state.fullscreenMessage ? this.state.fullNotificationIconUrl : ""
        newMessage.translations = [];

        if (this.state.selectAllButton) {
            newMessage.topics.push(``);
        } else {
            this.state.selectedDevices.forEach(selected => {
                newMessage.topics.push(`${selected.residentId}/${selected._id}`);
            });
        }

        const now = moment(new Date()).startOf('minute');
        let messageDate = moment(new Date());
        let messageEnd;

        if (this.state.scheduleDay && this.state.hourSelected && this.state.minuteSelected && this.state.dayTime) {
            messageDate = moment(this.state.scheduleDay.format('MM-DD-YYYY') + ' ' + this.state.hourSelected.number + ':' + this.state.minuteSelected.number + ' ' + this.state.dayTime.text, 'MM-DD-YYYY hh:mm A');
            messageEnd = this.state.notificationMessage ? moment(messageDate).add(this.state.messageModalSeconds, 'm') : moment(messageDate).add(this.state.messageModalHours, 'h')
        }

        if (messageDate < now) {
            let nowHour = now.hour() > 12 ? now.hour() - 12 : now.hour();
            let nowMinute = now.minutes();
            let nowDayTime = now.hour() > 11 ? 'PM' : 'AM';
            let nowDay = now.clone().startOf('day');

            let hourObject = {
                number: undefined,
                text: '',
            }

            let minuteObject = {
                number: undefined,
                text: '',
            }

            const datTimeObject = {
                text: nowDayTime,
            }
            if (nowHour === undefined) {
                hourObject = {
                    number: undefined,
                    text: '',
                }
            } else {

                hourObject = {
                    number: nowHour,
                    text: ('0' + nowHour).slice(-2),
                }
            }

            if (nowMinute === undefined) {
                minuteObject = {
                    number: undefined,
                    text: '',
                }
            } else {

                minuteObject = {
                    number: nowMinute,
                    text: ('0' + nowMinute).slice(-2),
                }
            }
            this.setState({
                hourSelected: hourObject,
                minuteSelected: minuteObject,
                dayTime: datTimeObject,
                scheduleDay: nowDay,
            });

            const message = `Cannot select a time in the past`
            sweetAlert('error', message, 'alert_AddEditActivity_PastTime_Error');

            return;
        }

        if (this.state.messageEs !== '') {
            const spanishObj = {
                languageCode: 'es',
                title: this.state.titleEs,
                message: this.state.messageEs,
            }

            newMessage.translations.push(spanishObj);
        }

        if (this.state.messageFr !== '') {
            const frenchObj = {
                languageCode: 'fr',
                title: this.state.titleFr,
                message: this.state.messageFr,
            }

            newMessage.translations.push(frenchObj);
        }


        newMessage.messageDate = new Date(messageDate);
        newMessage.messageEnd = new Date(messageEnd);

        if (this.state.selectAllButton) {
            this.props.AddMessageFilter(localStorage.getItem('communityId'), this.state.filterObj, newMessage, this.state.sortColumn, this.state.sortDesc);
        }
        else {
            this.props.AddMessage(newMessage, localStorage.getItem('communityId'));
        }


        this.cleanModal();
    };

    //#endregion


    //#Region filters handlers
    openFilters = () => {
        this.setState({
            openFilters: this.props.openFilters,
            AnchorElId: this.props.filtersAnchorElId

        });
    }

    onFilterChange = (filterObj) => {
        const community = localStorage.getItem('communityId')
        if (filterObj) {

            this.setState({
                filterObj: filterObj,
                currentPage: 0,
                selectAllButton: false,
                selectedDevices: []
            }, () => {
                this.props.GetDevicesSorted(community, this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
                this.props.isSelectedDevices([]);
            });

        }

    }

    GetFilteredDevices = (filterObj) => {

        let devices = Array.isArray(this.props.tableData) ? [...this.props.tableData] : [];

        let devicesFiltered = undefined;

        devicesFiltered = devices;

        if (filterObj) {
            if (filterObj.ResidentFilter) {
                devicesFiltered = devicesFiltered.filter(item => item.residentName.trim() === filterObj.ResidentFilter.trim());
            }
            if (filterObj.SerialNumberFilter) {
                devicesFiltered = devicesFiltered.filter(item => item.serial && item.serial.trim() === filterObj.SerialNumberFilter.trim());
            }
            if (filterObj.zoneNameFilter) {
                devicesFiltered = devicesFiltered.filter(item => item.residentLocation.trim() === filterObj.zoneNameFilter.trim());
            }
        }

        return devicesFiltered;

    }
    //#endregion

    handleIconsCombo = (e, option) => {
        if (!option) {

            this.setState((prevState) => ({ openIconsCombo: !prevState.openIconsCombo }));
        } else {
            this.setState({ openIconsCombo: option });
        }
    }

    handleIconsComboOnBlur = () => {
        this.setState({ openIconsCombo: false })
    }

    handleSelectIcon = (iconObj) => {

        if (iconObj) {
            const iconUrl = iconObj && iconObj.iconUrl ? iconObj.iconUrl : '';

            this.setState({ fullNotificationIconSelected: iconObj, fullNotificationIconUrl: iconUrl, openIconsModal: false })
        }
    }

    onClickContinueRegisterModal = () => {
        if (!((this.state.fullscreenMessage && this.state.onErrorModalTitle) || this.state.onErrorModalMessage))
            this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }))
    }

    setIdsPaginationHandler = () => {
        try {
            const pagContainer = document.getElementsByClassName('MuiPagination-ul');
            if (pagContainer && pagContainer.length > 0 && pagContainer[0]) {
                const pag = pagContainer[0];
                const liElements = pag.getElementsByTagName('li');
                if (liElements && liElements.length >= 4) {
                    for (let i = 0; i < liElements.length; i++) {
                        liElements[i].removeAttribute('id')
                    }
                    const btn_GoToFist = liElements[0];
                    if (btn_GoToFist) {
                        btn_GoToFist.setAttribute('id', 'pag_btn_gotofirst');
                        btn_GoToFist.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_back = liElements[1];
                    if (btn_back) {
                        btn_back.setAttribute('id', 'pag_btn_goback');
                        btn_back.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_forward = liElements[liElements.length - 2];
                    if (btn_forward) {
                        btn_forward.setAttribute('id', 'pag_btn_goforward');
                        btn_forward.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_GoToLast = liElements[liElements.length - 1];
                    if (btn_GoToLast) {
                        btn_GoToLast.setAttribute('id', 'pag_btn_gotolast');
                        btn_GoToLast.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }

                    for (let i = 2; i < liElements.length - 2; i++) {
                        const btn = liElements[i].getElementsByTagName('button');

                        if (btn && btn.length > 0 && btn[0] && btn[0].textContent.length > 0) {
                            liElements[i].setAttribute('id', `pagElement_${btn[0].textContent}`);
                        }
                    }
                }
            }
        } catch (err) { }
    }


    handleChangeTab = (event, newValue) => {
        this.setState({ translationTab: newValue });
    };

    a11yProps(lng) {
        return {
            id: `vertical-translation-tab-${lng}`,
            'aria-controls': `vertical-tabpanel-${lng}`,
        };
    }

    handleChangeTranslationIndex = (index) => {
        this.setState({ translationTab: index })
    }

    handleSort = (column) => {

        const currentColumn = this.state.sortColumn;

        const updState = {
            sortColumn: currentColumn,
            sortDesc: this.state.sortDesc,
            currentPage: 0,
            filtersApplied: true
        }

        if (currentColumn !== column) {
            updState.sortColumn = column
            updState.sortDesc = true;
        } else {
            updState.sortDesc = !this.state.sortDesc
        }

        this.setState(updState, async () => {
            const resp = await this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);

            if (this.state.selectAllButton) {
                this.SelectAllDevicesActive(resp)
            }
        })

    }





    render() {
        //Set IDS PAGINATION
        setTimeout(() => {
            this.setIdsPaginationHandler();
        }, 100);


        const RenderModalDayComponent = ({ daysToAdd }) => {

            let day = "";
            if (this.state.stepCounter === 0)
                day = moment(new Date()).add(daysToAdd, 'days');
            else
                day = moment(new Date()).add(daysToAdd + 7, 'days');

            const today = moment(new Date());
            const scheduleDay = this.state.scheduleDay ? this.state.scheduleDay : undefined;
            const sameDay = day.format('yyyy/MM/DD') === today.format('yyyy/MM/DD') ? true : false;
            const isScheduleDay = scheduleDay ? scheduleDay.format('yyyy/MM/DD') === day.format('yyyy/MM/DD') : false;

            return (
                <Grid item className={day < today ? "scheduleModalDisabledCell" : "scheduleModalCell"} onClick={() => this.handleDayClick(day, today)}>
                    <Grid item className="dayTitle">{day.format('ddd').toUpperCase()}</Grid>
                    <Grid item className={isScheduleDay ? "ScheduleModalDate scheduleModalScheduleDay" : sameDay ? "ScheduleModalDate scheduleModalToday" : "ScheduleModalDate"}>{day.format('D')}</Grid>
                </Grid>
            );
        };


        if (this.props.deviceReducerType === UPDATE_DEVICE_SUCCESS || this.props.deviceReducerType === ADD_DEVICE_SUCCESS) {
            this.setState({ currentPage: 0 }, () => this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj));
        }

        const week = [0, 1, 2, 3, 4, 5, 6];

        const currentData = this.props.tableData && Array.isArray(this.props.tableData) ? this.props.tableData : [];
        const total = this.props.total ? this.props.total : 0;

        const displayHeaders = this.state.isMobile ? 'none' : 'flex';
        const thumbClass = this.state.openTranslations ? 'switchThumbChecked' : 'switchThumb'
        const trackClass = this.state.openTranslations ? 'switchTrackChecked' : 'switchTrack'

        //ThumbnailImage
        const ThumbnailImage = ({ alt, url }) => {

            const styles = {
                img: {
                    height: '70px',
                    width: '70px',
                    borderRadius: '50%',
                }
            }
            return (
                <img
                    alt={'Thumbnail ' + alt}
                    style={{ ...styles.img }}
                    src={url}
                >
                </img>
            );
        };

        return (
            <div >
                <form >
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="imgalignrigth-engage appbtn-details-engage">
                                <div id="cancel_btn" className="appbtn-engage redbtn-engage" onClick={this.props.closeDialog}>
                                    Cancel
                                </div>
                                <div id='message_btn' className='appbtn-engage purplebtn-engage' onClick={() => this.setState({ openMessageModal: true })}>
                                    Message
                                </div>
                                <div id='reboot_btn' className='appbtn-engage redbtn-engage' onClick={() => this.setState({ openRebootModal: true, rebootMessage: true })}>
                                    Reboot
                                </div>
                                <div id='new_device_btn' className='appbtn-engage purplebtn-engage' onClick={() => this.setState({ openModal: true })} style={{ display: (this.state.isUpdDevice === true) ? 'none' : 'block' }}>
                                    Register
                                </div>
                                <div id='export_device_btn' className='appbtn-engage purplebtn-engage' onClick={this.handleExport} style={{ display: (this.state.isUpdDevice === true) ? 'none' : 'block' }}>
                                    Export Device
                                </div>
                                <div id='update_device_btn' className={(localStorage.getItem('superAdmin') === "true") ? 'appbtn-engage yellowbtn-engage' : 'appbtn-engage skybluebtn-angage'}
                                //  onClick={this.handleEditDevice}
                                >
                                    Update
                                </div>
                                <div id='unregister_btn' className='appbtn-engage' onClick={this.handleUnregister}>
                                    Unregister
                                </div>
                                <div id='cancel_device_btn' className="appbtn-engage redbtn-engage" onClick={this.handleCancelUpdateDevice}>
                                    Cancel
                                </div>
                                <div id="save_device_btn" className="appbtn-engage skybluebtn-engage" style={{ display: (this.state.isUpdDevice === false) ? 'none' : 'block' }} onClick={this.handleUpdateDevice}>
                                    Save
                                </div>
                                <div id='device_filters_btn' className='appbtn-engage skybluebtn-angage' onClick={this.openFilters}>
                                    Open Filters
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    {
                        !this.state.isUpdDevice ?
                            ///DEVICE LIST
                            <React.Fragment>
                                <Grid container>
                                    <Grid item container justify='center' alignContent='center'>
                                        <Grid id='Device_title' item className='PageTitle'>
                                            {
                                                this.state.selectAllButton ?
                                                    `Selected Devices (${total} of ${total})` :
                                                    this.state.selectedDevices.length > 0 ?
                                                        `Selected Devices (${this.state.selectedDevices.length} of ${total})`
                                                        :
                                                        `Device (${total})`
                                            }

                                        </Grid>
                                    </Grid>
                                    <Grid container className='GridColumnTitle' justifyContent='center' alignItems='center' style={{ flexGrow: 1, display: displayHeaders }} >
                                        <Grid item md={1} id='addEditDevice_Headers' style={{}} >
                                            <Button id='addEditDevice_Headers_SelectAll' className="selectAllButton selectAllButtonDeviceMod" onClick={() => this.SelectAllDevicesHandler()}>
                                                Select All
                                            </Button>
                                        </Grid>
                                        <Grid item md={4} style={{}} id='addEditDevice_Headers_Resident'>
                                            Resident
                                            <IconButton onClick={() => this.handleSort('lowerName')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'lowerName' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'lowerName' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'lowerName') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={2} style={{}} id='addEditDevice_Headers_Location'>
                                            Location
                                            <IconButton onClick={() => this.handleSort('lowerLocation')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'lowerLocation' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'lowerLocation' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'lowerLocation') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={2} style={{}} id='addEditDevice_Headers_DOCSIS'>
                                            DOCSIS MAC
                                            <IconButton onClick={() => this.handleSort('docsis')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'docsis' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'docsis' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'docsis') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={2} style={{}} id='addEditDevice_Headers_SerialNumber'>
                                            Serial Number

                                            <IconButton onClick={() => this.handleSort('serial')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'serial' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'serial' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'serial') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={1} style={{}} id='addEditDevice_Headers_Status'>Status</Grid>
                                    </Grid>
                                    <Grid container  >
                                        {
                                            currentData.map((item, index) => {

                                                if (currentData.length === index + 1) { /* We call the reference in the last row */
                                                    return (
                                                        <Grid item container ref={this.lastDeviceRef} key={index} className='DeviceCell' alignContent='center' onClick={(e) => { this.handleEdit(e, item); }} style={{ backgroundColor: '#1f1f1f', padding: '5px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', textAlign: 'center' }}>
                                                            <Grid item container justify='center' alignContent='center' className='CheckboxBlue RepairsCell' xs={1}>
                                                                <Checkbox
                                                                    id={`device_checkbox_${item._id}`}
                                                                    checked={this.state.selectedDevices && this.state.selectedDevices.length > 0 ? this.state.selectedDevices.find(device => device._id === item._id) !== undefined ? true : false : false}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={() => this.ToogleCheckBoxHandler(item)}
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                                                    checkedIcon={
                                                                        <CheckBoxIcon fontSize="large" />
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item container onClick={(e) => { this.handleEdit(e, item); }} xs={12} sm={12} md={4} justify='center' alignContent='center' style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }} >
                                                                <Grid item container xs={4} alignContent='center' justify='center'>
                                                                    <Grid item>
                                                                        <ThumbnailImage alt={index} url={item.residentPictureUrl} />
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container xs={8} style={{ paddingLeft: '15px' }}>{item.residentName}</Grid>
                                                            </Grid>
                                                            <Grid item container onClick={(e) => { this.handleEdit(e, item); }} xs={12} sm={12} md={2} alignContent='center' justify='center'>
                                                                <Grid item>
                                                                    {item.residentLocation}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container onClick={(e) => { this.handleEdit(e, item); }} xs={12} sm={12} md={2} alignContent='center' justify='center'>
                                                                <Grid item>
                                                                    {item.docsis}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container onClick={(e) => { this.handleEdit(e, item); }} xs={12} sm={12} md={2} alignContent='center' justify='center'>
                                                                <Grid item>
                                                                    {item.serial}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container xs={12} sm={12} md={1} style={{ textAlign: 'center' }}>

                                                                <this.GetStatusIcons active={item?.active} lastConnectionDate={item?.lastConnectionDate} />

                                                            </Grid>
                                                        </Grid>
                                                    )
                                                } else {
                                                    return (
                                                        <Grid item container key={index} className='DeviceCell' alignContent='center' onClick={(e) => { this.handleEdit(e, item); }} style={{ backgroundColor: '#1f1f1f', padding: '5px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', textAlign: 'center' }}>
                                                            <Grid item container justify='center' alignContent='center' className='CheckboxBlue RepairsCell' xs={1}>
                                                                <Checkbox
                                                                    id={`device_checkbox_${item._id}`}
                                                                    checked={this.state.selectedDevices && this.state.selectedDevices.length > 0 ? this.state.selectedDevices.find(device => device._id === item._id) !== undefined ? true : false : false}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={() => this.ToogleCheckBoxHandler(item)}
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                                                    checkedIcon={
                                                                        <CheckBoxIcon fontSize="large" />
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item container onClick={(e) => { this.handleEdit(e, item); }} xs={12} sm={12} md={4} justify='center' alignContent='center' style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }} >
                                                                <Grid item container xs={4} alignContent='center' justify='center'>
                                                                    <Grid item>
                                                                        <ThumbnailImage alt={index} url={item.residentPictureUrl} />
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item container xs={8} style={{ paddingLeft: '15px' }}>{item.residentName}</Grid>
                                                            </Grid>
                                                            <Grid item container onClick={(e) => { this.handleEdit(e, item); }} xs={12} sm={12} md={2} alignContent='center' justify='center'>
                                                                <Grid item>
                                                                    {item.residentLocation}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container onClick={(e) => { this.handleEdit(e, item); }} xs={12} sm={12} md={2} alignContent='center' justify='center'>
                                                                <Grid item>
                                                                    {item.docsis}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container onClick={(e) => { this.handleEdit(e, item); }} xs={12} sm={12} md={2} alignContent='center' justify='center'>
                                                                <Grid item>
                                                                    {item.serial}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container xs={12} sm={12} md={1} style={{ textAlign: 'center' }}>

                                                                <this.GetStatusIcons active={item?.active} lastConnectionDate={item?.lastConnectionDate} />

                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }

                                            })
                                        }
                                    </Grid>
                                </Grid>

                                {/* ADD DEVICE MODAL */}
                                <Modal
                                    open={this.state.openModal}
                                    onClose={() => this.cleanModal()}
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                >
                                    <Paper elevation={3} className="register_modal" color='secondary' >
                                        <Grid item container xs={12} justify='flex-start' className="titleResidentModal">
                                            <Grid item container>
                                                Register Device
                                            </Grid>
                                        </Grid>
                                        <Grid container className="register_modal_content">
                                            <Grid item xs={12} style={{ display: 'grid' }}>
                                                <TextField
                                                    id='device_registermodal_resitrationcode'
                                                    autoFocus={true}
                                                    label={'Registration Code'}
                                                    placeholder={'Registration Code'}
                                                    value={this.state.registrationCode}
                                                    onChange={(e) => { this.setState({ registrationCode: this.CheckForValidCaracters(e.target.value) }) }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} style={{ display: 'grid' }}>
                                                <ResidentSelect
                                                    idToSet='device_registermodal_residentselect'
                                                    label={'Resident'}
                                                    onChangeHandler={
                                                        (evet, newItem) => {
                                                            if (newItem !== null && newItem !== '') {
                                                                this.setState({ residentSelected: newItem });
                                                                this.setState({ onErrorModalRegisteredResident: false });
                                                            } else {
                                                                this.setState({ residentSelected: undefined });
                                                                this.setState({ onErrorModalRegisteredResident: true });
                                                            }
                                                        }
                                                    }
                                                    optionsItemsIconsData={this.props.residentData ? this.props.residentData : []}
                                                    selected={this.state.residentSelected ? this.state.residentSelected : {}}
                                                />
                                            </Grid>
                                            <Grid item xs={12} style={{ display: 'grid' }}>
                                                <TextField
                                                    id='device_registermodal_location'
                                                    label={'Location'}
                                                    placeholder={'Location'}
                                                    value={this.state.residentSelected ? this.state.residentSelected.zoneName : ""}
                                                    onChange={(e) => { this.setState({ modalLocation: this.CheckForValidCaracters(e.target.value) }) }}
                                                    disabled={true}
                                                />
                                            </Grid>

                                            <Grid container justify='center' alignItems='flex-end' className="buttons_register_Modal">
                                                <Grid item >
                                                    <button
                                                        className={(this.state.onErrorModalRegistrationCode || this.state.onErrorModalRegisteredResident) ? "appbtnModal-engage register_modal_register_btn_disabled" : "appbtnModal-engage register_modal_register_btn"}
                                                        onClick={() => this.handleAddDevice()}
                                                        id='device_registermodal_registerbtn'
                                                        onKeyDown={(e) => { if (e && e.keyCode && e.keyCode === 13) { this.handleAddDevice(); } }}
                                                    >
                                                        Register
                                                    </button>
                                                    <button
                                                        id='device_registermodal_cancelbtn'
                                                        className="appbtnModal-engage register_modal_cancel_btn"
                                                        onClick={() => this.cleanModal()}
                                                        style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                                    >
                                                        Cancel
                                                    </button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Modal>
                            </React.Fragment>
                            :

                            //Device Edit Form
                            <React.Fragment>
                                <Grid container xs={12} spacing={5} style={{ marginTop: '30px' }} direction='row' alignItems='flex-start' justify='space-between'>
                                    <Grid item container direction='column' xs={4}>
                                        <Grid item className='SectionTitle' >General</Grid>
                                        <Grid id='device_addedit_general' item container xs={12} className=' GridColumn' >
                                            <Grid item xs={12} className='SectionContent' style={{ padding: '10px' }} >
                                                <TextField
                                                    id='device_addedit_general_serial'
                                                    name="serial"
                                                    label="Serial Number"
                                                    value={(this.state.deviceSelected) ? this.state.deviceSelected.serial : ''}
                                                    className='textField'
                                                    inputProps={{
                                                        className: 'textFieldInput'
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='SectionContent' style={{ padding: '10px' }}>
                                                <TextField
                                                    id='device_addedit_general_docsis'
                                                    name="docsis"
                                                    label="DOCSIS MAC"
                                                    value={(this.state.deviceSelected.docsis) ? this.state.deviceSelected.docsis : ''}
                                                    className='textField'
                                                    inputProps={{
                                                        className: 'textFieldInput'
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid item className='SectionTitle' style={{ marginTop: '30px', textAlign: 'left' }}>Network</Grid>
                                        <Grid id='device_addedit_network' item container xs={12} className=' GridColumn'>
                                            <Grid item xs={12} className='SectionContent' style={{ padding: '10px' }}>
                                                <TextField
                                                    id='device_addedit_network_ethernet'
                                                    name="Ethernet"
                                                    label="Ethernet MAC"
                                                    value={(this.state.deviceSelected.ethernet) ? this.state.deviceSelected.ethernet : ''}
                                                    className='textField'
                                                    inputProps={{
                                                        className: 'textFieldInput'
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='SectionContent' style={{ padding: '10px' }}>
                                                <TextField
                                                    id='device_addedit_network_wifimac'
                                                    name="WiFi MAC"
                                                    label="WiFi MAC"
                                                    value={(this.state.deviceSelected.wifiMac) ? this.state.deviceSelected.wifiMac : ''}
                                                    className='textField'
                                                    inputProps={{
                                                        className: 'textFieldInput'
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='SectionContent' style={{ padding: '10px' }}>
                                                <TextField
                                                    id='device_addedit_network_ssidwifi'
                                                    name="SSID WiFi"
                                                    label="SSID WiFi"
                                                    value={(this.state.deviceSelected.ssidWifi) ? this.state.deviceSelected.ssidWifi : ''}
                                                    className='textField'
                                                    inputProps={{
                                                        className: 'textFieldInput'
                                                    }}

                                                />
                                            </Grid>
                                            <Grid item xs={12} className='SectionContent' style={{ padding: '10px' }}>
                                                <TextField
                                                    id='device_addedit_network_ipaddress'
                                                    name="IP"
                                                    label="IP Address"
                                                    value={(this.state.deviceSelected.ip) ? this.state.deviceSelected.ip : ''}
                                                    className='textField'
                                                    inputProps={{
                                                        className: 'textFieldInput'
                                                    }}
                                                />
                                            </Grid>
                                            {/* <Grid item xs={12} className='SectionContent' style={{padding:'10px'}}>
                                            <TextField name="Subnet" label="Subnet" 
                                                value={(this.state.deviceSelected.subnet)?this.state.deviceSelected.subnet:''}
                                                className='textField'
                                                inputProps={{
                                                    className: 'textFieldInput'
                                                }}
                                            /> 
                                        </Grid>
                                        <Grid item xs={12} className='SectionContent' style={{padding:'10px'}}>
                                            <TextField name="Gateway" label="Gateway"
                                                value={(this.state.deviceSelected.gateway)?this.state.deviceSelected.gateway:''}
                                                className='textField'
                                                inputProps={{
                                                    className: 'textFieldInput'
                                                }} 
                                            /> 
                                        </Grid>
                                        <Grid item xs={12} className='SectionContent' style={{padding:'10px'}}>
                                            <TextField name="DNS" label="DNS" 
                                                value={(this.state.deviceSelected.dns)?this.state.deviceSelected.dns:''}
                                                className='textField'
                                                inputProps={{
                                                    className: 'textFieldInput'
                                                }}
                                            /> 
                                        </Grid> */}
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction='column' xs={4}>
                                        <Grid item className='SectionTitle'  >Registree</Grid>
                                        <Grid id='device_addedit_registree' item container xs={12} className=' GridColumn'>
                                            <Grid item xs={12} className='SectionContent' style={{ padding: '10px' }}>
                                                {/*
                                        <TextField name="residentName" label="Resident" 
                                           value={(this.state.deviceSelected.residentName)?this.state.deviceSelected.residentName:''}
                                           className='textField'
                                                inputProps={{
                                                    className: 'textFieldInput'
                                                }}
                                        />
                                        */}
                                                <ResidentSelect
                                                    idToSet='device_addedit_registree_resident'
                                                    label={'Resident'}
                                                    style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                    onChangeHandler={
                                                        (evet, newItem) => {
                                                            if (newItem !== null && newItem !== '') {
                                                                let deviceSelected = this.state.deviceSelected;
                                                                deviceSelected.residentId = newItem._id;
                                                                deviceSelected.residentLocation = newItem.zoneName;
                                                                deviceSelected.residentName = `${newItem.firstName} ${newItem.lastName}`;
                                                                deviceSelected.residentPictureUrl = newItem.pictureUrl;

                                                                this.setState({
                                                                    deviceSelected: deviceSelected,
                                                                    residentDetailSelected: newItem
                                                                });

                                                            } else {
                                                                this.setState({ residentDetailSelected: undefined });
                                                            }
                                                        }
                                                    }
                                                    optionsItemsIconsData={this.props.residentData ? this.props.residentData : []}
                                                    selected={this.state.residentDetailSelected ? this.state.residentDetailSelected : {}}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='SectionContent' style={{ display: 'grid', padding: '10px' }}>
                                                <TextField
                                                    id='device_addedit_registree_location'
                                                    name='Location'
                                                    label={'Location'}
                                                    placeholder={'Location'}
                                                    value={this.state.deviceSelected.residentLocation ? this.state.deviceSelected.residentLocation : ""}
                                                    className='textField'
                                                    inputProps={{
                                                        className: 'textFieldInput'
                                                    }}
                                                />
                                            </Grid>
                                            {/* <Grid item xs={12} className='SectionContent' style={{padding:'10px'}}>  
                                        <TextField name="Registration code" label="Registration code" 
                                            value={(this.state.deviceSelected.registrationcode)?this.state.deviceSelected.registrationcode:''}
                                            className='textField'
                                            inputProps={{
                                                className: 'textFieldInput'
                                            }}
                                        /> 
                                    </Grid> */}
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction='column' xs={4}>
                                        <Grid item className='SectionTitle' >Identifiers</Grid>
                                        <Grid id='device_addedit_registree_identifiers' item container xs={12} className=' GridColumn'>
                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                <Field
                                                    idToSet='device_addedit_registree_tags'
                                                    name="DeviceTags"
                                                    label="Tags"
                                                    value={this.state.textFieldActualText}
                                                    maxLength={20}
                                                    chipsOptions={this.state.chipsArray}
                                                    handlerOnChipDelete={(chipText) => this.handlerOnChipDelete(chipText)}
                                                    handlerOnClickAddButton={() => { this.setState({ textFieldActualText: '' }); this.handleOnClickAddButton(); }}
                                                    onChange={(e) => { this.handleOnchangeTextField(e.target.value) }}
                                                    onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.setState({ textFieldActualText: '' }); this.handleOnClickAddButton(); } }}
                                                    component={renderTextFieldWithChips}
                                                    inputClass='SectionContent'
                                                    disabled={false}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </React.Fragment>
                    }

                    <React.Fragment>
                        {/* MESSAGE MODAL */}
                        <Modal
                            open={this.state.openMessageModal}
                            onClose={() => this.cleanModal()}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            onRendered={() => { this.setState({ onErrorModalMessage: true, onErrorModalTitle: true }) }}
                        >
                            <Paper elevation={0} className="paperModal deviceModal" color='secondary'>
                                <Grid container xs={12}>
                                    <Grid item container xs={12} className="titleResidentModal">
                                        <Grid style={{ textAlign: 'left' }}>
                                            New Message
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {
                                    <Grid item container xs={12} justify='center' alignItems='center' >
                                        <Stepper nonLinear activeStep={this.state.activeStep} className="stepperModal">
                                            <Step key={0} className={this.state.activeStep > 0 ? "StepStyles" : ""}><StepLabel onClick={() => { this.setState({ activeStep: 0 }) }} className={this.state.activeStep > 0 ? "StepLabelStyles" : ""}></StepLabel></Step>
                                            <Step key={1} className={this.state.activeStep > 1 ? "StepStyles" : ""}><StepLabel onClick={() => { this.setState({ activeStep: 1 }) }} className={this.state.activeStep > 1 ? "StepLabelStyles" : ""}></StepLabel></Step>
                                            <Step key={2}><StepLabel></StepLabel></Step>
                                        </Stepper>
                                    </Grid>
                                }
                                <Grid container xs={12} justify='center' alignItems='center'>
                                    <SwipeableViews
                                        axis={'x'}
                                        index={this.state.activeStep}
                                        onChangeIndex={this.handleChangeIndex}
                                        style={{ width: '95%', height: '100%', padding: '0', }}
                                    >
                                        {/* TabPanel Names */}
                                        <TabPanel value={this.state.activeStep} index={0} dir={'x'} style={{ padding: '0', }} >
                                            <Grid container xs={12} justify='center' alignItems='space-between' style={{ height: '530px' }} >
                                                <Grid item container xs={12} justify='center' alignItems='center' className="subtitleResidentModal">
                                                    <Grid item >
                                                        Select Type
                                                    </Grid>
                                                </Grid>
                                                <Grid item container xs={12} justify='center' alignItems='center'>
                                                    <Grid id='device_messageModal_notificationtype' item container xs={5} justify='center' alignItems='center' onClick={() => this.notificationClick()} className={this.state.notificationMessage ? 'deviceModalTypeSection deviceModalTypeSelected' : 'deviceModalTypeSection'}>
                                                        <Grid container xs={10} direction='colum' className='deviceGridColum'>
                                                            <Grid container xs={4} direction='colum' className='deviceModalNotification'>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container justify='center'>
                                                            <Grid item xs={12} className='deviceModalTitle'>
                                                                <span>Notification</span>
                                                            </Grid>
                                                            <Grid item xs={12} className='deviceModalDescription'>
                                                                <span>Non-intrusive. Auto-hides after 30 seconds of inaction.</span>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid id='device_messageModal_fullscreentype' item container xs={5} justify='center' alignItems='center' onClick={() => this.fullClick()} className={this.state.fullscreenMessage ? 'deviceModalTypeSection deviceModalTypeSelected' : 'deviceModalTypeSection'}>
                                                        <Grid container xs={10} direction='colum' className='deviceGridColumFull'>
                                                            <Grid container xs={12} direction='colum' className='deviceModalFullscreen-Line'>
                                                            </Grid>
                                                            <Grid container xs={7} direction='colum' className='deviceModalFullscreen-Line'>
                                                            </Grid>
                                                            <Grid container xs={9} direction='colum' className='deviceModalFullscreen-Line'>
                                                            </Grid>
                                                            <Grid container xs={6} direction='colum' alignItems='center' className='deviceModalFullscreen'>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container justify='center'>
                                                            <Grid item xs={12} className='deviceModalTitle'>
                                                                <span>Fullscreen</span>
                                                            </Grid>
                                                            <Grid item xs={12} className='deviceModalDescription'>
                                                                <span>Disruptive. Requires user action for dismissal.</span>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item container xs={12} justify='center' alignItems='flex-end' className="buttonsModal" >
                                                    <Grid item
                                                        id='device_messageModal_type_cancelbtn'
                                                        className="appbtn-engage"
                                                        onClick={() => this.cleanModal()}
                                                        style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                                    >
                                                        Cancel
                                                    </Grid>
                                                    <Grid item
                                                        id='device_messageModal_type_continuebtn'
                                                        className="appbtn-engage"
                                                        style={{ ...this.Modal.visibleButton, backgroundColor: '#009edd' }}
                                                        onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }))}
                                                    >
                                                        Continue
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                        {/* TabPanel Profile Picture */}
                                        <TabPanel value={this.state.activeStep} index={1} dir={'x'} style={{ padding: '0', }}>
                                            <Grid container justify='center' alignItems='space-between' style={{ height: '530px' }}>
                                                <Grid item container xs={12} justify='center' alignItems='center' className="subtitleResidentModal">
                                                    <Grid item>
                                                        Enter Message Details
                                                    </Grid>
                                                </Grid>
                                                <Grid item container xs={7} justify='center' alignItems='center'>
                                                    {
                                                        this.state.fullscreenMessage ?
                                                            <Grid item container xs={12} md={12} lg={6} justify='flex-start' direction='column' style={{ paddingBottom: '25px', }}>
                                                                <img
                                                                    src={this.state.fullNotificationIconUrl}
                                                                    alt='No icon selected'
                                                                    className="iconStyleDevice"
                                                                />
                                                                <Button id='select_icon_btn' variant='filled' className={this.state.fullNotificationIconSelected ? "SelectIconBtn SelectIconBtnIconSelected" : "SelectIconBtn"} onClick={() => { this.setState((prevState) => ({ openIconsModal: !prevState.openIconsModal })); }}>
                                                                    Select Icon
                                                                </Button>
                                                            </Grid> : ""
                                                    }
                                                    <Grid item xs={12} className="contentModal">
                                                        {
                                                            this.state.fullscreenMessage ?
                                                                <Grid xs={12}>
                                                                    <TextField
                                                                        id='device_messageModal_messagedetails_title'
                                                                        error={this.state.onErrorModalTitle}
                                                                        onBlur={() => {
                                                                            this.isOnError('title')
                                                                            this.setState({ isFocusTitle: false })
                                                                        }}
                                                                        helperText={(!this.state.messageModalTitle || (this.state.messageModalTitle && this.state.messageModalTitle.length <= 0)) ? this.state.errorGenericText : this.state.errorMaxCharactersTitle ? this.state.errorMaxCharactersTitle : undefined}
                                                                        style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                                        label={'Title'}
                                                                        placeholder={'Title'}
                                                                        value={this.state.messageModalTitle}
                                                                        onChange={(e) => { this.handleOnchangeTitleField(e.target.value) }}
                                                                        onFocus={() => { this.setState({ isFocusTitle: true }) }}
                                                                    />
                                                                    {
                                                                        this.state.isFocusTitle ?
                                                                            <Grid item xs={12} style={{ textAlign: 'right', opacity: '.56', fontFamily: 'Gotham-Book', paddingRight: '10px' }}>
                                                                                {this.state.messageModalTitle ? this.state.messageModalTitle.length : 0}/25
                                                                            </Grid>
                                                                            :
                                                                            undefined
                                                                    }
                                                                </Grid>

                                                                : ""
                                                        }
                                                    </Grid>
                                                    <Grid item xs={12} className="contentModal">
                                                        <TextField
                                                            id='device_messageModal_messagedetails_message'
                                                            autoFocus={this.setState.notificationMessage}
                                                            error={this.state.onErrorModalMessage}
                                                            onBlur={() => {
                                                                this.isOnError('message')
                                                                this.setState({ isFocusMessage: false })
                                                            }}
                                                            helperText={(!this.state.messageModalMessage || (this.state.messageModalMessage && this.state.messageModalMessage.length <= 0)) ? this.state.errorGenericText : this.state.errorMaxCharactersBody ? this.state.errorMaxCharactersBody : undefined}

                                                            style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                            label={'Message'}
                                                            placeholder={'Message'}
                                                            value={this.state.messageModalMessage}
                                                            onChange={(e) => { this.handleOnchangeMessageField(e.target.value) }}
                                                            onFocus={() => { this.setState({ isFocusMessage: true }) }}
                                                        />

                                                        {this.state.isFocusMessage ?
                                                            <Grid item xs={12} style={{ textAlign: 'right', opacity: '.56', fontFamily: 'Gotham-Book', paddingRight: '10px' }}>
                                                                {
                                                                    (this.state.fullscreenMessage) ?
                                                                        this.state.messageModalMessage ? this.state.messageModalMessage.length + '/220' : 0 + '/220'
                                                                        :
                                                                        this.state.messageModalMessage ? this.state.messageModalMessage.length + '/40' : 0 + '/40'
                                                                }
                                                            </Grid>
                                                            :
                                                            undefined
                                                        }
                                                    </Grid>
                                                    <Grid item xs={12} className="contentModal">
                                                        {
                                                            this.state.fullscreenMessage ?
                                                                <TextField
                                                                    id='device_messageModal_messagedetails_durationmin'
                                                                    style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                                    label={'Duration (Hours)'}
                                                                    placeholder={'Hours'}
                                                                    inputProps={{
                                                                        step: 1,
                                                                        min: 0,
                                                                        max: 12,
                                                                        type: 'number'
                                                                    }}
                                                                    value={this.state.messageModalHours}
                                                                    onChange={(e) => { this.handleOnchangeMessageTime(e.target.value) }}
                                                                /> :
                                                                <TextField
                                                                    id='device_messageModal_messagedetails_durationhr'
                                                                    style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                                    label={'Duration (Seconds)'}
                                                                    placeholder={'Seconds'}
                                                                    disabled
                                                                    value={this.state.messageModalSeconds}
                                                                    onChange={(e) => { this.handleOnchangeMessageTime(e.target.value) }}
                                                                />
                                                        }
                                                    </Grid>
                                                    <Grid item container xs={12} alignItems='center' justify='flex-end' style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                                                        <span style={{ fontWeight: 'bold', textAlign: 'left', fontSize: '20px', opacity: '.56', color: 'white', marginRight: '1rem' }}>Add other translations</span>
                                                        <Switch
                                                            classes={{
                                                                root: 'switchRoot',
                                                                thumb: thumbClass,
                                                                track: trackClass,
                                                            }}
                                                            checked={this.state.openTranslations}
                                                            onClick={() => this.setState((prevState) => ({ openTranslations: !prevState.openTranslations }))}>
                                                        </Switch>

                                                    </Grid>
                                                    {
                                                        this.state.openTranslations &&
                                                        <Grid item container xs={12} className='contentModal'>
                                                            <Tabs
                                                                value={this.state.translationTab}
                                                                onChange={this.handleChangeTab}
                                                                aria-label="Translations tab"
                                                                className='translationTabs'
                                                                variant='scrollable'
                                                                TabIndicatorProps={{ style: { backgroundColor: '#009edd' } }}

                                                            >
                                                                <Tab label="ES" className={(this.state.translationTab === 0) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(0)} />
                                                                <Tab label="FR" className={(this.state.translationTab === 1) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(1)} />
                                                            </Tabs>

                                                            <SwipeableViews
                                                                axis='x'
                                                                index={this.state.translationTab}
                                                                onChangeIndex={this.handleChangeTranslationIndex}
                                                            >

                                                                <TabPanel value={0} index={0}>

                                                                    {
                                                                        this.state.fullscreenMessage &&
                                                                        <Grid item container xs={12} style={{ marginBottom: '1rem' }}>
                                                                            <Field
                                                                                name="titleEs"
                                                                                label="Titulo"
                                                                                maxLength={20}
                                                                                onChange={(e, newItem) => this.setState({ titleEs: newItem })}
                                                                                component={renderTextField}
                                                                                id='title_es'
                                                                            />

                                                                        </Grid>

                                                                    }

                                                                    <Grid item container xs={12}>
                                                                        <Field
                                                                            name="messageEs"
                                                                            label="Mensaje"
                                                                            maxLength={20}
                                                                            onChange={(e, newItem) => this.setState({ messageEs: newItem })}
                                                                            component={renderTextField}
                                                                            id='message_es'
                                                                        />
                                                                    </Grid>
                                                                </TabPanel>

                                                                <TabPanel value={1} index={1}>

                                                                    {
                                                                        this.state.fullscreenMessage &&
                                                                        <Grid item container xs={12} style={{ marginBottom: '1rem' }}>
                                                                            <Field
                                                                                name="titleFr"
                                                                                label="Titre"
                                                                                maxLength={20}
                                                                                onChange={(e, newItem) => this.setState({ titleFr: newItem })}
                                                                                component={renderTextField}
                                                                                id='title_fr'
                                                                            />
                                                                        </Grid>
                                                                    }


                                                                    <Grid item container xs={12}>
                                                                        <Field
                                                                            name="messageFr"
                                                                            label="message"
                                                                            maxLength={20}
                                                                            onChange={(e, newItem) => this.setState({ messageFr: newItem })}
                                                                            component={renderTextField}
                                                                            id='message_fr'
                                                                        />

                                                                    </Grid>
                                                                </TabPanel>

                                                            </SwipeableViews>


                                                        </Grid>
                                                    }
                                                </Grid>
                                                <Grid item container xs={12} justify='center' alignItems='flex-end' className="buttonsModal">
                                                    <Grid item
                                                        id='device_messageModal_messagedetails_backbtn'
                                                        className='appbtn-engage'
                                                        onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep - 1 }))}
                                                        style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                                    >
                                                        Back
                                                    </Grid>
                                                    <Grid item
                                                        id='device_messageModal_messagedetails_continuebtn'
                                                        className={((this.state.fullscreenMessage && this.state.onErrorModalTitle) || this.state.onErrorModalMessage) ? "appbtnModal-engage register_modal_register_btn_disabled" : "appbtnModal-engage register_modal_register_btn"}
                                                        onClick={this.onClickContinueRegisterModal}
                                                    >
                                                        Continue
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                        {/* TabPanel Tags */}
                                        <TabPanel value={this.state.activeStep} index={2} dir={'x'} style={{}}>
                                            <Grid container justify='center' alignItems='space-between' style={{ height: '530px' }} >
                                                <Grid item container xs={12} justify='center' alignItems='center' className="subtitleResidentModal">
                                                    <Grid item >
                                                        Schedule Message
                                                    </Grid>
                                                </Grid>
                                                <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity">
                                                    {/* fixed options */}
                                                    <Grid item container xs={12} justify='center' alignItems='center'>
                                                        <Grid id='device_messageModal_schedulemessage_nowscheduleoption' item className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 1) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()), 1)}>Now</Grid>
                                                        {
                                                            moment(new Date()).hour() < 12 ?
                                                                <Grid id='device_messageModal_schedulemessage_noontodayscheduleoption' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 2) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()).startOf('day').add(12, 'hours'), 2)}>Noon Today</Grid>
                                                                :
                                                                undefined
                                                        }
                                                        {
                                                            moment(new Date()).day() !== 6 ?
                                                                <Grid id='device_messageModal_schedulemessage_noontomorrowscheduleoption' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 3) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()).add(1, 'days').startOf('day').add(12, 'hours'), 3)}>Noon Tomorrow</Grid>
                                                                :
                                                                undefined
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item container xs={12} alignItems='center' justify='center' className="contentModal">
                                                    <Grid item container xs={1} justify='center' alignItems='center'>
                                                        <IconButton id='device_messageModal_schedulemessage_backwardarrow' aria-label="leftArrow" onClick={() => this.AddStep(-1)} disabled={this.state.disabledBackIcon}>
                                                            <ArrowBackIosIcon style={{ fontSize: 40, color: (this.state.disabledBackIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item container xs={10} justify='center' alignItems='center'>
                                                        {
                                                            week ? week.map(
                                                                day => {
                                                                    return (
                                                                        <RenderModalDayComponent key={'DayComponent' + day} daysToAdd={day} />
                                                                    );
                                                                }
                                                            ) :
                                                                undefined
                                                        }
                                                    </Grid>
                                                    <Grid item container xs={1} justify='center' alignItems='center'>
                                                        <IconButton id='device_messageModal_schedulemessage_forwardarrow' aria-label="RightArrow" onClick={() => this.AddStep(1)} disabled={this.state.disabledFowardIcon}>
                                                            <ArrowForwardIosIcon style={{ fontSize: 40, color: (this.state.disabledFowardIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                                <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity">
                                                    {/* Time Selection */}
                                                    <Grid item container xs={9} justify='space-between' className="scheduleModalTimeListDevices">
                                                        <Grid item container xs={4}>
                                                            <ChevronList
                                                                idToSet='device_messageModal_schedulemessage_hr'
                                                                onArrowClick={this.onArrowClick}
                                                                onChangeHandler={this.onChangeHandler}
                                                                optionSelected={this.state.hourSelected}
                                                                placeHolder='hr'
                                                            />
                                                        </Grid>
                                                        <Grid item xs={1} className="ModalColon">:</Grid>
                                                        <Grid item xs={4}>
                                                            <ChevronList
                                                                idToSet='device_messageModal_schedulemessage_min'
                                                                onArrowClick={this.onArrowClick}
                                                                onChangeHandler={this.onChangeHandler}
                                                                optionSelected={this.state.minuteSelected}
                                                                placeHolder='min'
                                                            />
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <ChevronList
                                                                idToSet='device_messageModal_schedulemessage_daytime'
                                                                onArrowClick={this.onArrowClick}
                                                                onChangeHandler={this.onChangeHandler}
                                                                optionSelected={this.state.dayTime}
                                                                placeHolder='AM'
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item container xs={12} justify='center' alignItems='flex-end' className="buttonsModal">
                                                    <Grid item
                                                        id='device_messageModal_schedulemessage_backbtn'
                                                        className='appbtn-engage'
                                                        onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep - 1 }))}
                                                        style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                                    >
                                                        Back
                                                    </Grid>
                                                    <Grid item
                                                        id='device_messageModal_schedulemessage_sendbtn'
                                                        //style={(this.state.onErrorModalFirstName || this.state.onErrorModalLastName) ? this.Modal.visibleDisabledButton :{...this.Modal.visibleButton,backgroundColor:'#009edd'} }
                                                        className={(this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.hourSelected === undefined || this.state.minuteSelected === undefined) ? "appbtnModal-engage register_modal_register_btn_disabled" : "appbtnModal-engage register_modal_register_btn"}
                                                        onClick={() => this.handleAddMessage()}
                                                        disabled={(this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.hourSelected === undefined || this.state.minuteSelected === undefined)}
                                                    >
                                                        Send
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                    </SwipeableViews>
                                </Grid>
                            </Paper>
                        </Modal>
                        {/* REBOOT MODAL */}
                        <Modal
                            open={this.state.openRebootModal}
                            onClose={() => this.cleanModal()}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                        >
                            <Paper elevation={0} className="paperModal" color='secondary'>
                                <Grid container xs={12}>
                                    <Grid item container xs={12} className="titleResidentModal">
                                        <Grid style={{ textAlign: 'left' }}>
                                            Reboot
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container xs={12} justify='center' alignItems='center'>
                                    <Grid container style={{ width: '85%', height: '100%', padding: '40px 0px' }}>
                                        <Grid container justify='center' alignItems='space-between' style={{ height: '490px' }} >
                                            <Grid item container xs={12} justify='center' alignItems='center' className="subtitleResidentModal">
                                                <Grid item >
                                                    Schedule Reboot
                                                </Grid>
                                            </Grid>
                                            <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity">
                                                {/* fixed options */}
                                                <Grid item container xs={12} justify='center' alignItems='center'>
                                                    <Grid id='device_rebootmodal_nowscheduleOption' item className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 1) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()), 1)}>Now</Grid>
                                                    {
                                                        moment(new Date()).hour() < 12 ?
                                                            <Grid id='device_rebootmodal_noontodayscheduleOption' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 2) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()).startOf('day').add(12, 'hours'), 2)}>Noon Today</Grid>
                                                            :
                                                            undefined
                                                    }
                                                    {
                                                        moment(new Date()).day() !== 6 ?
                                                            <Grid id='device_rebootmodal_noontomorrowscheduleOption' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 3) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()).add(1, 'days').startOf('day').add(12, 'hours'), 3)}>Noon Tomorrow</Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>
                                            </Grid>
                                            <Grid item container xs={12} alignItems='center' justify='center' className="contentModal">
                                                <Grid item container xs={1} justify='center' alignItems='center'>
                                                    <IconButton aria-label="leftArrow" onClick={() => this.AddStep(-1)} disabled={this.state.disabledBackIcon}>
                                                        <ArrowBackIosIcon id='device_rebootmodal_arrowbackward' style={{ fontSize: 40, color: (this.state.disabledBackIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                                    </IconButton>
                                                </Grid>
                                                <Grid item container xs={10} justify='center' alignItems='center'>
                                                    {
                                                        week ? week.map(
                                                            day => {
                                                                return (
                                                                    <RenderModalDayComponent key={'DayComponent' + day} daysToAdd={day} />
                                                                );
                                                            }
                                                        ) :
                                                            undefined
                                                    }
                                                </Grid>
                                                <Grid item container xs={1} justify='center' alignItems='center'>
                                                    <IconButton aria-label="RightArrow" onClick={() => this.AddStep(1)} disabled={this.state.disabledFowardIcon}>
                                                        <ArrowForwardIosIcon id='device_rebootmodal_arrowforward' color='secondary' style={{ fontSize: 40, color: (this.state.disabledFowardIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                            <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity">
                                                {/* Time Selection */}
                                                <Grid item container xs={9} justify='space-between' className="scheduleModalTimeListDevices">
                                                    <Grid item container xs={4}>
                                                        <ChevronList
                                                            idToSet='device_rebootmodal_chevronlisthr'
                                                            onArrowClick={this.onArrowClick}
                                                            optionSelected={this.state.hourSelected}
                                                            onChangeHandler={this.onChangeHandler}
                                                            placeHolder='hr'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={1} className="ModalColon">:</Grid>
                                                    <Grid item xs={4}>
                                                        <ChevronList
                                                            idToSet='device_rebootmodal_chevronlistmin'
                                                            onArrowClick={this.onArrowClick}
                                                            optionSelected={this.state.minuteSelected}
                                                            onChangeHandler={this.onChangeHandler}
                                                            placeHolder='min'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <ChevronList
                                                            idToSet='device_rebootmodal_chevronlistdaytime'
                                                            onArrowClick={this.onArrowClick}
                                                            optionSelected={this.state.dayTime}
                                                            onChangeHandler={this.onChangeHandler}
                                                            placeHolder='AM'
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item container xs={12} justify='center' alignItems='flex-end' className="buttonsModal">
                                                <Grid item
                                                    id='device_rebootmodal_cancelbtn'
                                                    className='appbtn-engage'
                                                    onClick={() => this.cleanModal()}
                                                    style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                                >
                                                    Cancel
                                                </Grid>
                                                <Grid item
                                                    id='device_rebootmodal_updatebtn'
                                                    className={(this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.minuteSelected === undefined || this.state.hourSelected === undefined) ? "appbtnModal-engage register_modal_register_btn_disabled" : "appbtnModal-engage register_modal_register_btn"}
                                                    onClick={() => this.handleAddReboot()}
                                                    disabled={(this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.minuteSelected === undefined || this.state.hourSelected === undefined)}
                                                >
                                                    Update
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Paper>
                        </Modal>
                    </React.Fragment>
                </form>


                {
                    this.state.openFilters && this.state.AnchorElId ?
                        <DeviceFiltersDrawer
                            idAnchorEl={this.state.AnchorElId}
                            onClose={() => this.setState({ openFilters: false, AnchorElId: undefined }, () => this.props.closeFilters())}
                            residents={this.props.residentsNames}
                            serialNumbers={this.props.serials}
                            zoneNames={this.props.locations}
                            onFilterChange={this.onFilterChange}
                            filterObj={this.state.filterObj ? this.state.filterObj : {}}

                        />
                        :
                        undefined
                }
                {
                    this.state.openIconsModal === true ?

                        <IconsModal
                            icons={this.props.IconsData}
                            onSelectIcon={this.handleSelectIcon}
                            iconSelected={this.state.fullNotificationIconSelected}
                            onClose={() => { this.setState({ openIconsModal: false }) }}
                        />
                        :
                        undefined
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const deviceData = (state.deviceReducer && state.deviceReducer.deviceData) ? [...state.deviceReducer.deviceData] : [];
    const residentData = (state.residentReducer && state.residentReducer.residentData) ? state.residentReducer.residentData : [];
    const residentsNames = (state.deviceReducer && state.deviceReducer.residents) ? state.deviceReducer.residents : [];
    const locations = (state.deviceReducer && state.deviceReducer.locations) ? state.deviceReducer.locations : [];
    const serials = (state.deviceReducer && state.deviceReducer.serials) ? state.deviceReducer.serials : [];


    const IconsData = (state.categoryReducer && state.categoryReducer.IconsData) ? state.categoryReducer.IconsData : [];
    const total = (state.deviceReducer && state.deviceReducer.totalDevices) ? state.deviceReducer.totalDevices : 0;

    return {
        tableData: deviceData,
        residentData: residentData,
        IconsData: IconsData,
        deviceReducerType: (state.deviceReducer && state.deviceReducer.type) ? state.deviceReducer.type : "",
        total,
        serials,
        residentsNames,
        locations
    };
}

export default connect(mapStateToProps, {
    GetDevicesSorted,
    getResidentsByCommunity,
    AddDevice,
    GetDevice,
    UpdDevice,
    AddMessage,
    UnregisterResidents,
    GetIcons,
    GetDevicesLocations,
    GetDevicesResidents,
    GetDevicesSerials,
    UnregisterResidentsFilter,
    AddMessageFilter,
    ExportDevices
})(reduxForm({
    form: 'DeviceForm',
    validate,
    enableReinitialize: true,
})(AddEditDeviceV2));